import { validateStepSetChoice } from '../task-progress/validate-step-choice';
export function procedureProgressToProgressMap(progress, nodeMap) {
    var map = {};
    // there's no progression data, return an empty progress-map
    if ((progress === null || progress === void 0 ? void 0 : progress.steps) == null) {
        return map;
    }
    progress.steps.forEach(function (stepProgress, index) {
        var stepId = (stepProgress.id || stepProgress.step || index).toString();
        if (!nodeMap.hasOwnProperty(stepId)) {
            // outdated progress object, the step doesn't exist on the procedure anymore
            return;
        }
        var completed = null;
        if (stepProgress.completed != null) {
            var _a = validateStepSetChoice(stepProgress.set_choice, nodeMap[stepId]), pickedChoice = _a.pickedChoice, nextNode = _a.nextNode;
            completed = {
                at: stepProgress.completed,
                by: stepProgress.completed_by || null,
                pickedChoice: pickedChoice,
                nextNode: nextNode,
            };
        }
        map[stepId] = {
            fields: stepProgress.fields || {},
            automation: stepProgress.automation || {},
            completed: completed,
        };
    });
    return map;
}
